export const providerAdminOptions = (adminSettings, intl, developerSettings) => [
  ...(adminSettings.edit_company_settings
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.companyDetails",
            defaultMessage: "Company details",
          }),
          key: "company-details",
          permission: adminSettings.edit_company_settings,
        },
      ]
    : []),
  ...(adminSettings.view_users
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.users",
            defaultMessage: "Users",
          }),
          key: "users",
          permission: adminSettings.view_users,
        },
      ]
    : []),
  ...(adminSettings.view_user_roles
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.userRoles",
            defaultMessage: "User roles",
          }),
          key: "user-roles",
          permission: adminSettings.view_user_roles,
        },
      ]
    : []),
  ...(adminSettings.view_teams
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.teams",
            defaultMessage: "Teams",
          }),
          key: "teams",
          permission: adminSettings.view_teams,
        },
      ]
    : []),
  ...(adminSettings.manage_account_mappings
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.accountMapping",
            defaultMessage: "Account mapping",
          }),
          key: "account-mapping",
          permission: adminSettings.manage_account_mappings,
        },
      ]
    : []),
  ...(developerSettings?.create_developer_tokens
    ? [
        {
          label: intl.formatMessage({
            id: "settings.side-menu.apiTokens",
            defaultMessage: "API Tokens",
          }),
          key: "api-tokens",
          permission: true,
        },
      ]
    : []),
];

export const providerSettingsOptions = (testIds) => [
  {
    keyName: "your-details",
    testId: testIds.YOUR_DETAILS_BUTTON,
    message: "settings.side-menu.yourDetails",
    defaultText: "Your details",
  },
  {
    keyName: "notifications",
    testId: testIds.NOTIFICATIONS_BUTTON,
    message: "general.notifications",
    defaultText: "Notifications",
  },
  {
    keyName: "documents-agreements",
    testId: testIds.ADDRESS_BOOK_BUTTON,
    message: "settings.side-menu.documentsAgreements",
    defaultText: "Documents and agreements",
  },
];
